import React from 'react';
import { observer } from 'mobx-react';
import { ServerNotificationNew, ServerNotificationOld } from './';
import { useProfileFeatureFlags } from '../../hooks';

export const ServerNotification: React.FC = observer(() => {
    const { newAlarms: isNewAlarmsFlag } = useProfileFeatureFlags();

    return isNewAlarmsFlag ? <ServerNotificationNew /> : <ServerNotificationOld />;
});
